import { useEffect, useRef, useState } from 'react';
import { useGetAddress } from '#api/location';
import { LocationPin } from '#assets/svg';
import { HEADER_HEIGHT } from '#const/layout';
import { Gym } from '#types/gyms';
import FibudCertificate from '#assets/svg/fibud-certificate.svg';
import { getCoachCareer } from '#utils/timeFormatter';
import {
  CoachInfoWrap,
  NameArea,
  LocationArea,
  GradeArea,
  Tags,
  Tag
} from './styles';
type Tags = { id: string; name: string };

interface Props {
  name: string;
  isTutor: boolean;
  tags: Tags[];
  gymLocation: Gym;
  startAthletic?: string;
  clinicalDataCount: number;
  nameLocation?: React.MutableRefObject<number>;
}

export const CoachInfo = ({
  name,
  isTutor,
  tags,
  gymLocation,
  startAthletic,
  clinicalDataCount,
  nameLocation
}: Props) => {
  const divRef = useRef<HTMLDivElement>(null);
  const careerYear = getCoachCareer(startAthletic);
  const { data: gymAddressData } = useGetAddress(
    gymLocation?.long,
    gymLocation?.lat
  );
  const [gymAddress, setGymAddress] = useState<string>('');

  useEffect(() => {
    if (gymAddressData && gymAddressData.documents?.length > 0) {
      setGymAddress(
        `${gymAddressData.documents[0].address.region_2depth_name} ${gymAddressData.documents[0].address.region_3depth_name}`
      );
    } else setGymAddress('위치정보 없음');
  }, [gymAddressData]);

  useEffect(() => {
    const nameRef = divRef.current;
    if (!nameRef) return;
    const nameRefLocation = nameRef.getBoundingClientRect();
    if (!nameLocation) return;
    nameLocation.current =
      nameRefLocation.top + nameRefLocation.height - HEADER_HEIGHT;
  }, []);

  return (
    <CoachInfoWrap>
      <Tags data-text-type="c1">
        {tags.map(tag => (
          <Tag key={tag.id}>{tag.name}</Tag>
        ))}
      </Tags>
      <NameArea data-text-type="t1" ref={divRef}>
        <p className="flex gap-4 items-center">
          {name} 전문가
          {isTutor && <img src={FibudCertificate} />}
        </p>
      </NameArea>
      <LocationArea data-text-type="c1">
        <LocationPin />
        <p>{gymAddress}</p>
      </LocationArea>
      <GradeArea data-text-type="c1">
        <p>경력 {careerYear}년</p>
        <p>트레이닝 성과 {clinicalDataCount}건</p>
      </GradeArea>
    </CoachInfoWrap>
  );
};
